<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { computed } from "vue";

const { tm } = useI18n();

const faq = computed(() => tm("calculators.day-rune.faq") as unknown);
</script>

<template>
  <h4
    class="font-semibold text-xl md:text-2xl leading-[24px] md:leading-[32px] text-brown mb-4 w-full text-left"
  >
    {{ faq.first_title }}
  </h4>
  <p class="text-base leading-[20px] text-brown mb-1 w-full text-left">
    <template v-for="(p, i) in faq.first_paragraph" :key="i">
      <span class="md:font-bold" v-if="p.type === 'bold'">{{ p.text }}</span>
      <span v-else>{{ p.text }}</span>
    </template>
  </p>
  <ul class="list-disc pl-7 text-left text-brown text-base leading-[20px] mb-4">
    <li v-for="(item, i) in faq.list" :key="i">
      <span class="md:font-bold">{{ item.bold }}</span>
      {{ item.text }}
    </li>
  </ul>
  <h6
    class="text-base leading-[20px] text-brown mb-1 w-full text-left md:font-bold"
  >
    {{ faq.second_title }}
  </h6>
  <p class="text-base leading-[20px] text-brown mb-1 w-full text-left">
    {{ faq.second_paragraph }}
  </p>
</template>

<style scoped></style>
